// for importing global styles
import './src/styles/reset.scss';
import './src/styles/global.scss';
